import { Question } from '../types';

export const questions: Question[] = [
  {
    id: 'scriptType',
    questionKey: 'scriptGenerator.questions.scriptType.question',
    type: 'single',
    required: true,
    optionsKey: 'scriptGenerator.questions.scriptType.options',
    options: [
      'commercial',
      'tutorial',
      'story',
      'documentary',
      'socialMedia',
      'productDemo',
      'interview',
      'presentation',
      'other'
    ]
  },
  {
    id: 'duration',
    questionKey: 'scriptGenerator.questions.duration.question',
    type: 'single',
    required: true,
    optionsKey: 'scriptGenerator.questions.duration.options',
    options: [
      '15-30s',
      '30-60s',
      '1-2m',
      '2-5m',
      '5-10m',
      '10m+'
    ]
  },
  {
    id: 'audience',
    questionKey: 'scriptGenerator.questions.audience.question',
    type: 'single',
    required: true,
    optionsKey: 'scriptGenerator.questions.audience.options',
    options: [
      'general',
      'professionals',
      'students',
      'children',
      'youngAdults',
      'middleAged',
      'seniors',
      'niche'
    ]
  },
  {
    id: 'tone',
    questionKey: 'scriptGenerator.questions.tone.question',
    type: 'single',
    required: true,
    optionsKey: 'scriptGenerator.questions.tone.options',
    options: [
      'professional',
      'conversational',
      'energetic',
      'serious',
      'friendly',
      'humorous',
      'dramatic',
      'inspirational',
      'educational'
    ]
  },
  {
    id: 'genre',
    questionKey: 'scriptGenerator.questions.genre.question',
    type: 'single',
    required: false,
    optionsKey: 'scriptGenerator.questions.genre.options',
    options: [
      'drama',
      'comedy',
      'action',
      'informational',
      'persuasive',
      'entertainment',
      'documentary',
      'corporate',
      'educational'
    ]
  },
  {
    id: 'setting',
    questionKey: 'scriptGenerator.questions.setting.question',
    type: 'text',
    required: false,
    placeholderKey: 'scriptGenerator.questions.setting.placeholder'
  },
  {
    id: 'characters',
    questionKey: 'scriptGenerator.questions.characters.question',
    type: 'text',
    required: false,
    placeholderKey: 'scriptGenerator.questions.characters.placeholder'
  },
  {
    id: 'keyPoints',
    questionKey: 'scriptGenerator.questions.keyPoints.question',
    type: 'text',
    required: false,
    placeholderKey: 'scriptGenerator.questions.keyPoints.placeholder'
  },
  {
    id: 'userNarration',
    questionKey: 'scriptGenerator.questions.userNarration.question',
    type: 'text',
    required: false,
    placeholderKey: 'scriptGenerator.questions.userNarration.placeholder',
    hasCheckbox: true,
    checkboxKey: 'scriptGenerator.questions.userNarration.checkbox'
  },
  {
    id: 'callToAction',
    questionKey: 'scriptGenerator.questions.callToAction.question',
    type: 'text',
    required: false,
    placeholderKey: 'scriptGenerator.questions.callToAction.placeholder',
    dependsOn: 'scriptType',
    dependsOnValue: ['commercial', 'socialMedia', 'productDemo']
  }
];
